import React from 'react';

import { Container, Group, SegmentedControl, createStyles } from '@mantine/core';
import { CalendarNav, CalendarPrev, CalendarToday, CalendarNext } from '@mobiscroll/react';

import { ProgramCalendarView } from './types';

const useStyles = createStyles(theme => ({
  headerWrapper: {
    width: '100%',
    fontFamily: `${theme.fontFamily} !important`,
    paddingTop: theme.spacing.xs,
    fontSize: theme.fontSizes.sm,
    borderBottom: 0,
  },
  fontOverride: {
    fontFamily: `${theme.fontFamily} !important`,
  },
}));

interface IProgramCalendarNavigationButtonsProps {
  view: ProgramCalendarView;
  setView: React.Dispatch<React.SetStateAction<ProgramCalendarView>>;
}

const ProgramCalendarNavigationButtons = ({
  view,
  setView,
}: IProgramCalendarNavigationButtonsProps): JSX.Element => {
  const { classes } = useStyles();

  return (
    <Container fluid className={classes.headerWrapper}>
      <Group grow noWrap spacing={0}>
        <CalendarNav className={classes.fontOverride} />
        <Group position='center'>
          <SegmentedControl
            data-cy='programCalendarViewSwitcher'
            size='sm'
            value={view}
            onChange={(value: ProgramCalendarView) => setView(value)}
            data={[
              { label: 'Month', value: 'month' },
              { label: 'Agenda', value: 'agenda' },
            ]}
          />
        </Group>
        <Group noWrap spacing={0} position='right'>
          <CalendarPrev className={classes.fontOverride} />
          <CalendarToday className={classes.fontOverride} />
          <CalendarNext className={classes.fontOverride} />
        </Group>
      </Group>
    </Container>
  );
};

export default ProgramCalendarNavigationButtons;
